/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
export class CandidatesHiddenOpportunityEntity extends Entity {
  candidateId: string | null = null;
  id: string = '';
  opportunityId: string | null = null;
  static override key = 'CandidatesHiddenOpportunity';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidatesHiddenOpportunity' in input
    ) {
      const { CandidatesHiddenOpportunity: wrapped, ...rest } = input as {
        CandidatesHiddenOpportunity: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}